/** Outlook / Microsoft mail operational issues. */
import type { IssueDefinition } from "../issue-definition";
import { ISSUE_CATEGORY, ISSUE_FAULT } from "../issue-enums";

export const OUTLOOK_ISSUES = {
  OUTLOOK_MAILBOX_INACCESSIBLE: {
    category: ISSUE_CATEGORY.PROVIDER,
    message:
      "Outlook mailbox is inactive, soft-deleted, or hosted on-premise — subscription renewal failed",
    severity: "high",
    fault: ISSUE_FAULT.USER_ACTION,
    userTitle: "Outlook mailbox unreachable",
    userGuidance:
      "This Outlook mailbox is inactive, deleted, or hosted on-premise, so Nexus can't watch it for new mail. Use an active cloud mailbox, then reconnect."
  },
  OUTLOOK_TOKEN_REVOKED: {
    category: ISSUE_CATEGORY.PROVIDER,
    message: "Outlook OAuth token has been revoked or access was denied",
    severity: "critical",
    fault: ISSUE_FAULT.USER_ACTION,
    userTitle: "Outlook connection revoked",
    userGuidance:
      "Access to this Outlook account was revoked, so email can't be sent or received. Reconnect Outlook to restore it."
  },
  OUTLOOK_SCOPE_INSUFFICIENT: {
    category: ISSUE_CATEGORY.PROVIDER,
    message: "Outlook OAuth token is missing the send-as permission",
    severity: "high",
    fault: ISSUE_FAULT.USER_ACTION,
    userTitle: "Outlook permissions out of date",
    userGuidance:
      "The Outlook connection is missing the permission needed to send mail. Reconnect Outlook and grant send access."
  },
  OUTLOOK_QUOTA_EXCEEDED: {
    category: ISSUE_CATEGORY.PROVIDER,
    message: "Outlook message submission blocked — mailbox quota or send limit exceeded",
    severity: "high",
    fault: ISSUE_FAULT.PROVIDER,
    userTitle: "Outlook send limit reached",
    userGuidance:
      "Microsoft blocked sending because the mailbox quota or send limit was reached. Sending resumes once the limit clears."
  },
  OUTLOOK_INVALID_RECIPIENT: {
    category: ISSUE_CATEGORY.PROVIDER,
    message: "Outlook message has one or more invalid recipients",
    severity: "medium",
    fault: ISSUE_FAULT.USER_ACTION,
    userTitle: "Invalid email recipient",
    userGuidance:
      "Outlook rejected a message because one or more recipient addresses are invalid. Check the recipients and try again."
  }
} as const satisfies Record<string, IssueDefinition>;
